function restrictNumber(number, min, max) {
    return Math.min(Math.max(parseInt(number), min), max)
}


export default restrictNumber